import { RequestParams } from '../interfaces/apiRequest.interface';
import { RequestQueryBuilderParamsEnum } from '../consts/enums';

export const buildRequestParamsByType = (
  obj:  RequestParams<string[] | string | boolean>,
  type: RequestQueryBuilderParamsEnum,
): RequestParams<string> => {
  return Object.keys(obj).reduce((acc: RequestParams<string>, key): RequestParams<string> => {
    if (Array.isArray(obj[key])) {
      acc[`${key}__${type}`] = (obj[key] as string[]).join(',') || undefined;
    } else if (type === RequestQueryBuilderParamsEnum.exact) {
      acc[`${key}`] = obj[key] as string;
    } else if (type === RequestQueryBuilderParamsEnum.not) {
      acc[`${key}__${RequestQueryBuilderParamsEnum.not}`] = obj[key] as string;
    } else {
      acc[`${key}__${type}`] = obj[key] as string || undefined;
    }

    return acc;
  }, {});
};

export const buildOrder = (orders: RequestParams<string>): string | undefined => {
  const ordersKey = Object.keys(orders);

  return ordersKey.reduce((acc: string, orderKey: string, i: number) => {
    const sortQuery = i + 1 === ordersKey.length ?
      `${orders[orderKey]}${orderKey}` :
      `${orders[orderKey]}${orderKey},`;

    return `${acc}${sortQuery}`;
  }, '') || undefined;
};

export const buildSelect = (
  selectList: string[] | undefined,
): string | undefined => selectList?.join(',') || undefined;
